import Swal from "sweetalert2";

/**
 * Enhanced Alert System
 * Modernizes the SweetAlert2 experience with premium aesthetics,
 * consistent iconography, and refined styling.
 */

const swalConfig = {
    customClass: {
        container: 'ipcs-swal-container',
        popup: 'ipcs-swal-popup',
        header: 'ipcs-swal-header',
        title: 'ipcs-swal-title',
        closeButton: 'ipcs-swal-close',
        icon: 'ipcs-swal-icon',
        image: 'ipcs-swal-image',
        content: 'ipcs-swal-content',
        htmlContainer: 'ipcs-swal-html',
        input: 'ipcs-swal-input',
        actions: 'ipcs-swal-actions',
        confirmButton: 'ipcs-swal-confirm',
        cancelButton: 'ipcs-swal-cancel',
        footer: 'ipcs-swal-footer'
    },
    buttonsStyling: false,
    showCloseButton: true,
    heightAuto: false,
};

const getIconColor = (type) => {
    switch (type) {
        case 'success': return '#10b981';
        case 'error': return '#ef4444';
        case 'warning': return '#f59e0b';
        case 'info': return '#3b82f6';
        default: return '#1a2c52';
    }
};

export const getAlert = (title, message, type) => {
    return Swal.fire({
        ...swalConfig,
        title: title || (type ? type.charAt(0).toUpperCase() + type.slice(1) : ''),
        text: message,
        icon: type,
        iconColor: getIconColor(type),
        confirmButtonText: '<i class="fa fa-times mr-2"></i> Close',
    });
};

export const getAlertWithOk = (title, message, type, callback) => {
    return Swal.fire({
        ...swalConfig,
        title: title || (type ? type.charAt(0).toUpperCase() + type.slice(1) : ''),
        text: message,
        icon: type,
        iconColor: getIconColor(type),
        confirmButtonText: '<i class="fa fa-check mr-2"></i> OK',
    }).then((result) => {
        if (result.isConfirmed && typeof callback === "function") {
            callback();
        }
    });
};

export const getConfirmAlert = (title, message, type) => {
    return Swal.fire({
        ...swalConfig,
        title: title || 'Are you sure?',
        text: message,
        icon: type || 'warning',
        iconColor: getIconColor(type || 'warning'),
        showCancelButton: true,
        confirmButtonText: '<i class="fa fa-check mr-2"></i> Yes, Proceed',
        cancelButtonText: '<i class="fa fa-times mr-2"></i> No, Cancel',
        reverseButtons: true,
    });
};

/**
 * Quick toast notification
 */
export const showToast = (message, type = 'success') => {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    Toast.fire({
        icon: type,
        title: message
    });
};
